var _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.26488 11.465L8.60001 18.4713L19.3676 4.71338V3.43949L12.427 6.6879L6.26488 11.465Z",
    fill: "url(#paint0_linear_5_1432)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60001 18.4713L19.3676 8.3758V3.43949L15.4757 8.78981L9.37838 12.7389L8.60001 18.4713Z",
    fill: "url(#paint1_linear_5_1432)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.596 7.95265C0.718475 8.2787 0.729964 9.52389 1.61335 9.83369L6.26487 11.465L19.3676 3.43949L9.3784 12.7389L17.7086 19.0396C18.2964 19.4842 19.1469 19.1618 19.2922 18.4392L22.6462 1.75965C22.8006 0.991581 22.0519 0.35227 21.3175 0.625135L1.596 7.95265Z",
    fill: "url(#paint2_linear_5_1432)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5_1432",
    x1: 12.8162,
    y1: 3.43949,
    x2: 12.8162,
    y2: 18.4713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#25FD74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#09923B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5_1432",
    x1: 13.9838,
    y1: 8.65685,
    x2: 13.9838,
    y2: 18.4713,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#24EF6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#24FB72"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5_1432",
    x1: 11.8055,
    y1: 0.561005,
    x2: 11.8055,
    y2: 19.2429,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A8F5C4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60F295"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.9c7593de920c2e2513769d88acd784d9.svg";
export { ForwardRef as ReactComponent };